import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  DealerQueryKeys,
  deleteNote,
  getNoteHistory,
  postNote,
  putNote
} from "./dealerFunctions";

export const usePostNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postNote,
    onError: () => {
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTION] });
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTIONS] });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTION] });
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTIONS] });
    }
  });
};

export const usePutNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putNote,
    onError: () => {
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTION] });
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTIONS] });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTION] });
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTIONS] });
    }
  });
};

export const useNoteHistory = (auctionId: number, enabled: boolean) => {
  return useQuery({
    queryKey: [DealerQueryKeys.NOTE_HISTORY, auctionId],
    queryFn: () => getNoteHistory(auctionId),
    enabled
  });
};

export const useDeleteNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteNote,
    onError: () => {
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTION] });
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTIONS] });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTION] });
      queryClient.invalidateQueries({ queryKey: [DealerQueryKeys.AUCTIONS] });
    }
  });
};
